export default __webpack_public_path__ + "static/oswald-bold-4cc74cc05cd5868cc309c7d1a8c70d0b.ttf";